import React from 'react';
import { AlertCircle, CheckCircle2, Info, AlertTriangle, X } from 'lucide-react';
import { useNotification } from '../contexts/NotificationContext';
import { cn } from '../lib/utils';

const GlobalNotificationDisplay = () => {
    const { notifications, removeNotification } = useNotification();

    const getIcon = (type) => {
        switch (type) {
            case 'success':
                return <CheckCircle2 className="h-5 w-5 text-emerald-600" />;
            case 'error':
                return <AlertCircle className="h-5 w-5 text-red-600" />;
            case 'warning':
                return <AlertTriangle className="h-5 w-5 text-amber-600" />;
            case 'info':
            default:
                return <Info className="h-5 w-5 text-blue-600" />;
        }
    };

    const getBgColor = (type) => {
        switch (type) {
            case 'success':
                return 'bg-emerald-50 border-emerald-200';
            case 'error':
                return 'bg-red-50 border-red-200';
            case 'warning':
                return 'bg-amber-50 border-amber-200';
            case 'info':
            default:
                return 'bg-blue-50 border-blue-200';
        }
    };

    const getTextColor = (type) => {
        switch (type) {
            case 'success':
                return 'text-emerald-800';
            case 'error':
                return 'text-red-800';
            case 'warning':
                return 'text-amber-800';
            case 'info':
            default:
                return 'text-blue-800';
        }
    };

    if (notifications.length === 0) return null;

    return (
        <div className="fixed top-4 right-4 z-50 space-y-2 max-w-md">
            {notifications.map((notification) => (
                <div
                    key={notification.id}
                    className={cn(
                        'flex items-start gap-3 p-4 rounded-lg border shadow-lg animate-in slide-in-from-top-2 fade-in',
                        getBgColor(notification.type)
                    )}
                >
                    <div className="flex-shrink-0 mt-0.5">
                        {getIcon(notification.type)}
                    </div>
                    <div className={cn('flex-1 text-sm font-medium', getTextColor(notification.type))}>
                        {notification.message}
                    </div>
                    <button
                        onClick={() => removeNotification(notification.id)}
                        className="flex-shrink-0 ml-2 text-gray-400 hover:text-gray-600"
                        aria-label="Close notification"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default GlobalNotificationDisplay;
